module.exports = __webpack_public_path__ + "static/media/niop-logo.dbf716df.jpg";